import { MediaAssetRow } from "design-system/components/blocks/media-asset-row/media-asset-row";
import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { MediaAssetRowEntry } from "frontend/contentful/schema/blocks";
import { createMediaAssetRowProps } from "./media-asset-row.props";

export interface MediaAssetRowOptions {
  headerAbove?: boolean;
}

export const ContentfulMediaAssetRow = createContentfulComponent<
  MediaAssetRowEntry,
  MediaAssetRowOptions
>(({ entry, options }) => {
  const props = createMediaAssetRowProps(entry, options);

  return <MediaAssetRow {...props} />;
});
